import { defineComponent as _defineComponent } from 'vue'
import { getCurrentInstance, onBeforeUnmount, onMounted } from 'vue';
import Chart from '@/modules/Statistics/components/Chart.vue';
import PieChart from '@/modules/Statistics/components/PieChart.vue';
import TotalReport from '@/modules/Statistics/components/TotalReport.vue';
import TableReport from '@/modules/Statistics/components/TableReport.vue';
import ProjectsOverview from '@/modules/Statistics/components/ProjectsOverview.vue';
import Matrix from '@/modules/Statistics/components/Matrix.vue';
import News from '@/modules/Statistics/CMS/components/News.vue';
import { ReportTypes } from '@/modules/Statistics/interfaces/ReportTypes';
import { EventBusEvents } from '@/enums/global/EventBusEvents';
import { EventBus } from '@/helpers/EventBusHelper';
import { DashboardReportFields } from '@/modules/Statistics/interfaces/DashboardReport';
import {
    downloadReport as downloadReportHelper,
    DownloadReportData,
} from '@/modules/Statistics/helpers/StatisticsDashboardHelper';

interface Props {
    reports?: DashboardReportFields[];
    isEdit: boolean;
    isPrinting: boolean;
    tablePagination: { paginationSize: number; activePrintingReport: string };
    startDrag: (event: any) => void;
    onDrop: (event: any) => void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'StatisticsContent',
  props: {
    reports: null,
    isEdit: { type: Boolean },
    isPrinting: { type: Boolean },
    tablePagination: null,
    startDrag: null,
    onDrop: null
  },
  emits: ["expandTableForPrinting", "revertTableToNormalSize"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'expandTableForPrinting', reportId: string): void;
    (e: 'revertTableToNormalSize'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    reports?: DashboardReportFields[];
    isEdit: boolean;
    isPrinting: boolean;
    tablePagination: { paginationSize: number; activePrintingReport: string };
    startDrag: (event: any) => void;
    onDrop: (event: any) => void;
};





const { proxy } = getCurrentInstance()!;

const reportTypes = ReportTypes;

function downloadReport(data: DownloadReportData) {
    return downloadReportHelper(data, {
        refs: (proxy as any).$refs,
        htmlToPaper: (elementId, opts) => (proxy as any).$htmlToPaper(elementId, opts),
        translate: (key) => proxy?.$t(key) as string,
        onExpand: (reportId) => emit('expandTableForPrinting', reportId),
        onRevert: () => emit('revertTableToNormalSize'),
    });
}

EventBus.$on(EventBusEvents.downloadReport, downloadReport);

onBeforeUnmount(() => {
    EventBus.$off(EventBusEvents.downloadReport, downloadReport);
});

onMounted(() => {
    if (props.reports) {
        props.reports.sort((a, b) => a.position - b.position);
    }
});

return { __sfc: true,props, emit, proxy, reportTypes, downloadReport, Chart, PieChart, TotalReport, TableReport, ProjectsOverview, Matrix, News }
}

})